import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import axiosInstance from "../../config/axiosConfig";
import Actions from "../../components/courses/Actions";
import { CircularProgress } from "@mui/material";

const customModalStyles = {
    content: {
        padding: "20px",
        width: "80%",
        maxWidth: "600px",
        margin: "auto",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
};

const isImageFile = (url = "") =>
    /\.(jpg|jpeg|png|webp|gif|bmp|svg)(\?|$)/i.test(String(url).split("?")[0] || "");

const FilePreview = ({ url, alt, style }) => {
    if (!url) {
        return (
            <img
                src="/uo-16-9.webp"
                alt={alt || "Admission ad"}
                style={style}
            />
        );
    }

    if (isImageFile(url)) {
        return <img src={url} alt={alt || "Admission ad"} style={style} />;
    }

    const label = /\.pdf(\?|$)/i.test(url) ? "PDF" : "FILE";

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                ...style,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#f3f4f6",
                color: "#111827",
                textDecoration: "none",
                border: "1px solid #e5e7eb",
                boxSizing: "border-box",
            }}
        >
            <span style={{ fontSize: 28, fontWeight: 700 }}>{label}</span>
            <span style={{ fontSize: 12, marginTop: 6 }}>Open / Download</span>
        </a>
    );
};

export default function AdmissionAd() {
    const [AdmissionAds, setAdmissionAds] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editAdmissionAdId, seteditAdmissionAdId] = useState(null);
    const [sortByLatest, setSortByLatest] = useState(false);
    const [formData, setformData] = useState({
        file: "",
        name: "",
        openingDate: "",
        closingDate: "",
        type: "",
        display: "yes",
    });
    const [AdmissionAdFetchLoading, setAdmissionAdFetchLoading] = useState(false);
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [imgFile, setImgFile] = useState(null);
    const [imgPreview, setImgPreview] = useState(null);
    useEffect(() => {
        // Set image preview when formData.img changes (for edit case)
        if (formData.file) {
            setImgPreview(formData.file);
        }
    }, [formData.file]);

    useEffect(() => {
        // Fetch AdmissionAds on component mount
        fetchAdmissionAds();
    }, []);

    // Fetch all AdmissionAds
    const fetchAdmissionAds = async () => {
        setAdmissionAdFetchLoading(true);
        try {
            const response = await axiosInstance.get("admissionAd/all");
            setAdmissionAds(response.data.data);
        } catch (error) {
            console.error("Error fetching AdmissionAds:", error);
        }
        setAdmissionAdFetchLoading(false);
    };

    // Handle create AdmissionAd
    const handleCreateAdmissionAd = async (e) => {
        e.preventDefault();
        setbuttonLoading(true);
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key === "file") {
                return;
            }
            formDataToSend.append(key, formData[key]);
        });
        if (imgFile) {
            formDataToSend.append("file", imgFile);
        }
        try {
            await axiosInstance.post("admissionAd/create", formDataToSend);
            fetchAdmissionAds();
            setShowCreateModal(false);
            setImgFile(null);
            setImgPreview(null);
            Swal.fire("Success!", "AdmissionAd created successfully!", "success", 1500);
            setformData({
                file: "",
                name: "",
                openingDate: "",
                closingDate: "",
                type: "",
                display: "",
            });
        } catch (error) {
            console.error("Error creating AdmissionAd:", error);
            Swal.fire("Error", "Failed to create AdmissionAd", "error");
        }
        setbuttonLoading(false);
    };

    // Handle edit AdmissionAd
    const handleEditAdmissionAd = async (e) => {
        e.preventDefault();
        setbuttonLoading(true);
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key === "file") {
                return;
            }
            formDataToSend.append(key, formData[key]);
        });

        if (imgFile) {
            formDataToSend.append("file", imgFile);
        }
        formDataToSend.append("_method", "PUT");
        try {
            await axiosInstance.post(`admissionAd/change/${editAdmissionAdId}`, formDataToSend);
            fetchAdmissionAds();
            setShowEditModal(false);
            setImgFile(null);
            Swal.fire("Success!", "AdmissionAd updated successfully!", "success");
        } catch (error) {
            console.error("Error updating AdmissionAd:", error);
            const message = error.response?.data?.message || "Failed to update AdmissionAd";
            Swal.fire("Error", message, "error");
        }
        setbuttonLoading(false);
    };
    const handleViewAdmissionAd = async (id) => {
        setShowEditModal(true);

        try {
            setShowEditModal(true);
            seteditAdmissionAdId(id);
            const response = await axiosInstance.get(`admissionAd/single/${id}`);
            const data = response?.data?.data;

            setformData({
                file: data.file,
                name: data.name,
                openingDate: data.openingDate,
                closingDate: data.closingDate,
                type: data.type,
                display: data.display,
            });
        } catch (error) {
            console.error("Error updating AdmissionAd:", error);
            Swal.fire("Error", "Failed to update AdmissionAd", "error");
        }
    };
    // Handle delete AdmissionAd
    const handleDeleteAdmissionAd = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                await axiosInstance.delete(`admissionAd/delete/${id}`);
                fetchAdmissionAds();
                Swal.fire("Deleted!", "AdmissionAd deleted successfully", "success", 1500);
            }
        } catch (error) {
            console.error("Error deleting AdmissionAd:", error);
            Swal.fire("Error", "Failed to delete AdmissionAd", "error");
        }
    };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setformData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            //   if (fileSizeInMB > MAX_SIZE_MB) {
            //     alert(
            //       `File size exceeds ${MAX_SIZE_MB} MB. Please upload a smaller file.`
            //     );
            //     e.target.value = "";
            //   } else {
            setImgFile(file);
            setImgPreview(URL.createObjectURL(file));
            //   }
        }
    };
    const sortedAdmissionAds = sortByLatest
        ? [...AdmissionAds].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        : AdmissionAds || [];
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                    onClick={() => setShowCreateModal(true)}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        cursor: "pointer",
                    }}
                >
                    Create New AdmissionAd
                </button>
                <button
                    onClick={() => setSortByLatest((prev) => !prev)}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: sortByLatest ? "#2196F3" : "#f0f0f0",
                        color: sortByLatest ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        cursor: "pointer",
                        marginRight: "150px",
                    }}
                >
                    {sortByLatest ? "Show Default" : "Show Latest"}
                </button>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                {AdmissionAdFetchLoading ? (
                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 9999,
                        }}
                    >
                        {" "}
                        <CircularProgress />{" "}
                    </div>
                ) : (
                    sortedAdmissionAds.map((AdmissionAd) => (
                        <div
                            key={AdmissionAd._id}
                            style={{
                                width: "250px",
                                padding: "15px",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                textAlign: "center",
                            }}
                        >
                            <FilePreview
                                url={AdmissionAd.file}
                                alt={AdmissionAd.name || AdmissionAd.title}
                                style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    marginBottom: "15px",
                                    aspectRatio: "16/9",
                                }}
                            />
                            <h3>{AdmissionAd.name}</h3>
                            <p>{AdmissionAd.description}</p>
                            <Actions
                                courseId={AdmissionAd._id}
                                onEdit={handleViewAdmissionAd}
                                onDelete={handleDeleteAdmissionAd}
                            />
                        </div>
                    ))
                )}
            </div>

            <Modal
                isOpen={showCreateModal}
                onRequestClose={() => setShowCreateModal(false)}
                style={customModalStyles}
                contentLabel="Create New AdmissionAd"
            >
                <h2>Create New AdmissionAd</h2>
                <form onSubmit={handleCreateAdmissionAd}>
                    {[
                        { label: "name", name: "name", type: "text", required: true },
                        { label: "Type", name: "type", type: "text" },
                        { label: "Display", name: "display", type: "text" },
                        { label: "Opening Date", name: "openingDate", type: "date" },
                        { label: "Closing Date", name: "closingDate", type: "date" },

                    ].map(({ label, name, type, required, options }) => (
                        <div key={name} style={{ marginBottom: "10px" }}>
                            <label
                                style={{
                                    display: "block",
                                    fontWeight: "bold",
                                    marginBottom: "5px",
                                }}
                            >
                                {label}
                            </label>
                            {type === "dropdown" ? (
                                <select
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                >
                                    <option value="">Select an option</option>
                                    {options.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            ) : type === "textarea" ? (
                                <textarea
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "100px",
                                    }}
                                />
                            ) : (
                                <input
                                    type={type}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            )}
                        </div>
                    ))}
                    <div style={{ marginBottom: "10px" }}>
                        <label
                            style={{
                                display: "block",
                                fontWeight: "bold",
                                marginBottom: "5px",
                            }}
                        >
                            Upload
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            style={{
                                width: "100%",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                            }}
                        />
                    </div>
                    {imgPreview && (
                        <FilePreview
                            url={imgPreview}
                            alt="Preview"
                            style={{ width: "30%", height: "auto", marginBottom: "15px", minHeight: 80 }}
                        />
                    )}
                    <button
                        type="submit"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "10px",
                        }}
                    >
                        {buttonLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Create"
                        )}
                    </button>
                </form>
            </Modal>

            <Modal
                isOpen={showEditModal}
                onRequestClose={() => {
                    setformData({
                        file: "",
                        name: "",
                        openingDate: "",
                        closingDate: "",
                        type: "",
                        display: "",
                    });
                    setShowEditModal(false);
                }}
                style={customModalStyles}
                contentLabel="Edit AdmissionAd"
            >
                <h2>Edit AdmissionAd</h2>
                <form onSubmit={handleEditAdmissionAd}>
                    {[
                        { label: "name", name: "name", type: "text" },
                        { label: "Type", name: "type", type: "text" },
                        { label: "Display", name: "display", type: "text" },
                        { label: "Opening Date", name: "openingDate", type: "date" },
                        { label: "Closing Date", name: "closingDate", type: "date" },

                    ].map(({ label, name, type, required }) => (
                        <div key={name} style={{ marginBottom: "10px" }}>
                            <label
                                style={{
                                    display: "block",
                                    fontWeight: "bold",
                                    marginBottom: "5px",
                                }}
                            >
                                {label}
                            </label>
                            {type === "textarea" ? (
                                <textarea
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "100px", // Adjust height as needed
                                    }}
                                />
                            ) : (
                                <input
                                    type={type}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            )}
                        </div>
                    ))}
                    <div style={{ marginBottom: "10px" }}>
                        <label
                            style={{
                                display: "block",
                                fontWeight: "bold",
                                marginBottom: "5px",
                            }}
                        >
                            Upload
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            style={{
                                width: "100%",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                            }}
                        />
                    </div>
                    {imgPreview && (
                        <FilePreview
                            url={imgPreview}
                            alt="Preview"
                            style={{ width: "30%", height: "auto", marginBottom: "15px", minHeight: 80 }}
                        />
                    )}
                    <button
                        type="submit"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "10px",
                        }}
                    >
                        {buttonLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Update"
                        )}
                    </button>
                </form>
            </Modal>
        </div>
    );
}